
<template>
  <div class="min-h-screen bg-gray-50">
    <AppHeader v-if="showHeader" />
    <Toast />
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from '@/layouts/components/AppHeader.vue'
import Toast from '@/layouts/components/Toast.vue'

const route = useRoute()

// Hide header on auth pages
const showHeader = computed(() => {
  return !['login', 'register'].includes(route.name)
})
</script>

<style>
/* Global styles can be added here */

.card-header {
  @apply px-6 py-4 border-b border-gray-200;
}

.card-body {
  @apply px-6 py-4;
}

.btn-primary {
  @apply px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 transition-colors;
}

.btn-secondary {
  @apply px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors;
}

.form-input,
.form-select,
.form-textarea {
  @apply rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50;
}

.form-checkbox,
.form-radio {
  @apply rounded border-gray-300 text-primary-600 focus:ring-primary-500;
}
</style>